var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack309({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.44,10,6.9,9.8a1.07,1.07,0,0,0,.28.66.85.85,0,0,0,.6.22,1,1,0,0,0,.79-.43A3.65,3.65,0,0,0,9,8.46a1.8,1.8,0,0,1-1.42.66A2.13,2.13,0,0,1,6,8.41a2.62,2.62,0,0,1-.67-1.87A2.67,2.67,0,0,1,6,4.61a2.42,2.42,0,0,1,1.81-.73,2.46,2.46,0,0,1,2,.92,4.82,4.82,0,0,1,.77,3.05A4.89,4.89,0,0,1,9.75,11a2.62,2.62,0,0,1-2.09.95,2.19,2.19,0,0,1-1.49-.49A2.4,2.4,0,0,1,5.44,10Zm3.42-3.3a1.69,1.69,0,0,0-.34-1.13,1,1,0,0,0-.77-.4.87.87,0,0,0-.7.33,1.71,1.71,0,0,0-.28,1.08,1.72,1.72,0,0,0,.3,1.12A.94.94,0,0,0,7.83,8a.93.93,0,0,0,.73-.35A1.49,1.49,0,0,0,8.86,6.66Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8,
    cy: 8,
    r: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack309);
export default __webpack_public_path__ + "static/media/Symbolpack_3_09.e53f3441e9630083f358e6d2decbf89c.svg";
export { ForwardRef as ReactComponent };